var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import * as customersAPI from '@debbie/cortex/dist/api/customers';
import THEME from '../../../theme';
import Badge from '../../Badge';
import { Edit, XCircle } from '../../Icons';
const SecondaryEntity = (props) => {
    const { id, toggleEditModal, render, note, deleteEventType, enabled } = props;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(React.Fragment, null,
        React.createElement(Edit, { style: {
                cursor: 'pointer',
                float: 'right',
                marginLeft: '5px',
            }, onClick: () => toggleEditModal() }),
        React.createElement(XCircle, { style: {
                cursor: 'pointer',
                float: 'right',
            }, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                yield customersAPI.addEventToUser(props.user.customerId, props.user.userId, {
                    type: deleteEventType,
                    details: {
                        id,
                    },
                });
                yield c.customers.getById(props.user.customerId);
            }) }),
        render,
        note ? React.createElement("small", null,
            " - ",
            note) : '',
        ' ',
        !enabled && (React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.customers.secondaryEntityDisabled))));
};
export default SecondaryEntity;
//# sourceMappingURL=SecondaryEntity.js.map